import { BatchesService } from '@festina/datamart-general-types/datamart/services/BatchesService'
import { useFestinaMutation } from '@festina-life/authentication'

const method = BatchesService.batchesServiceDeleteDelete
type MethodParam = Parameters<typeof method>[0]

export const useDeleteDatamartBatch = () =>
  useFestinaMutation({
    component: 'dataMart',
    isScenario: false,
    roles: BatchesService.batchesServiceDeleteDelete_roles,
    mutateFunction: (arg: MethodParam) => method(arg),
  })
